const baseUrl: string = process.env.REACT_APP_API_URL || '';

class HomeSetting {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        params,
        uri: this.uri,
    });

    public post = (params: any) => ({
        baseUrl,
        method: 'patch',
        params,
        uri: this.uri,
    });
}

export default new HomeSetting('/cms/v1/settings/homepage');



// WEBPACK FOOTER //
// ./src/libraries/api/home-setting.tsx